import SiteDevicesTable from '@/features/devices/SiteDevicesTable';
import useAuth from '@/shared/context/auth-context';
import { FunctionComponent, ReactElement } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import { SiteContext } from '../index/Site';

const SiteDevices: FunctionComponent = (): ReactElement => {
	const { siteId } = useParams();
	const { user } = useAuth();
	const { site } = useOutletContext<SiteContext>();

	return (
		<SiteDevicesTable siteId={siteId} siteName={site?.name} customerName={user?.customer?.name} />
	);
};

export default SiteDevices;
